/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CAMPAIGN_RECORD_FETCH = gql`
  query campaignRecordFetch  {
    campaign {
      records( page: 1 limit: 5 ) {
        collection {
          id
          title
          remoteType
          locale
          address {
            street
            state
            city
            postalCode
            country
          }
          origin {
            ... on JobRecord {
              id
              title
              description
              salary
              jobType
              remoteType
              address {
                street
                state
                city
                postalCode
                country
              }
            }
          }
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_SOURCING = gql`
  query campaignRecordFetch( $search: SearchFilterInput) {
    campaign {
      records( page: 1 limit: 1 search: $search) {
        collection {
          id
          facebookPixelId
          jobBanner
          settings {
            landingPageType
            eosLandingPage
            googleTagManagerId
            completionMessage
            callToActionCompletionMessage
            completionCta {
              label
              url
              active
            }
          }
          companyJobBanner
          companyParameters {
            useBanner
            eosLandingPage
            landingPageType
          }
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_APPLICANT_SCORING = gql`
  query campaignRecordFetch( $search: SearchFilterInput) {
    campaign {
      records( page: 1 limit: 1 search: $search) {
        collection {
          id
          evaluationCriterias {
            id
            candidateAttribute {
              id
              name
              key
              type
              suggestions
              suggestionsOnly
            }
            metadata
          }
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_TALKSCORE_WEIGHT_DISTRIBUTION = gql`
  query campaignRecordFetch( $search: SearchFilterInput) {
    campaign {
      records( page: 1 limit: 1 search: $search) {
        collection {
          id
          talkscoreWeightDistribution
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_LISTING = gql`
  query campaignRecordFetch( $search: SearchFilterInput $page: Int $limit: Int) {
    campaign {
      records( search: $search, page: $page, limit: $limit ) {
        collection {
          id
          title
          remoteType
          address {
            street
            state
            city
            postalCode
            country
          }
          origin {
            ... on JobRecord {
              id
              title
              description
              salary
              salaryType
              brief
              jobType
              remoteType
              currencyType
            }
          }
          jobLandingPageUrl
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_PROMPT_SET_PRESCREENING = gql`
  query campaignRecordFetch( $search: SearchFilterInput $page: Int $limit: Int) {
    campaign {
      records( search: $search, page: $page, limit: $limit ) {
        collection {
          id
          prescreeningSet {
            id
            title
            latestAudit {
              createdAt
              action
              user {
                fullName
              }
            }
            records {
              id
              title
              categoryName
              legacyTag
              documentTag {
                name
                parameters {
                  processable
                  landingPageProcessable
                }
              }
              candidateAttribute{
                name
              }
            }
          }
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_FETCH_PROMPT_SET_ONBOARDING = gql`
  query campaignRecordFetch( $search: SearchFilterInput $page: Int $limit: Int) {
    campaign {
      records( search: $search, page: $page, limit: $limit ) {
        collection {
          id
          onboardingSet {
            id
            title
            latestAudit {
              createdAt
              action
              user {
                fullName
              }
            }
            records {
              id
              title
              categoryName
              legacyTag
              documentTag {
                name
                parameters {
                  processable
                  landingPageProcessable
                }
              }
              candidateAttribute{
                name
              }
            }
          }
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;

export const CAMPAIGN_RECORD_TITLE_FETCH = gql`
  query campaignRecordFetch( $search: SearchFilterInput $page: Int $limit: Int) {
    campaign {
      records( search: $search, page: $page, limit: $limit ) {
        collection {
          id
          title
        }
        metadata {
          ...pagemetadata
        }
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;